import { Exception } from '@core/exceptions/exception';

export class TokenNotFoundException extends Exception {
  constructor(message = 'The token is not found.') {
    super(message);
  }
}
